export default __webpack_public_path__ + "static/media/screenshot11.da144efc.jpg";